<!-- 个性设置 -->
<template>
  <div>
    <el-form :model="form" :rules="rules" ref="ruleForm" label-position="right" label-width="180px" class="demo-ruleForm">
      <div v-if="disabled" class="zcr" @click="prompt()"></div>
      <el-row>
        <el-col>
          <el-form-item label="系统主题：" prop="topMenu">
            <top-theme></top-theme>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="标签页关闭方式：" prop="labelClose">
            <el-radio-group v-model="form.labelClose" v-if="!disabled">
              <template v-for="item in tabNumData">
                <el-radio :label="item.value">{{item.label}}</el-radio>
              </template>
            </el-radio-group>
            <span v-else-if="disabled">
              <template v-for="item in tabNumData">
                <span v-if="item.value == form.labelClose">{{item.label}}</span>
              </template>
            </span>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="顶部菜单展示方式：" prop="topMenu">
            <el-radio-group v-model="form.topMenu" v-if="!disabled">
              <template v-for="item in topMenuLayoutData">
                <el-radio :label="item.value">{{item.label}}</el-radio>
              </template>
            </el-radio-group>
            <span v-else-if="disabled">
              <template v-for="item in topMenuLayoutData">
                <span v-if="item.value == form.topMenu">{{item.label}}</span>
              </template>
            </span>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="是否开启水印：" prop="topMenu">
            <el-switch v-model="form.watermarking" active-color="#13ce66" inactive-color="#ff4949" inactive-value="0" active-value="1" active-text="开" inactive-text="关"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { updateInfo} from "@/api/system/user"
  import { setStore } from "@/util/store"
  import { mapGetters } from "vuex"
  import topTheme from "@/page/index/top/top-theme"
  import crypto from "@/util/crypto";
  export default {
    components: {
      topTheme,
    },
    props: { user: Object,disabled:Boolean},
    computed: {
      ...mapGetters(["setup"])
    },
    inject: ["index"],
    data() {
      return {
        initialization: { // 初始化
          labelClose:"0",  // 标签栏关闭
          topMenu: "0", // 顶部菜单
          watermarking: "0", // 水印
        },
        form: {
          id:"",
        },
        tabNumData: [
          {
            label: "不关闭",
            value: "0",
          },
          {
            label: "点击顶部菜单关闭",
            value: "1",
          },
          {
            label: "点击左侧菜单关闭",
            value: "2",
          },
        ],
        topMenuLayoutData:[
          {
            label: "展开放置",
            value: "0",
          },
          {
            label: "折叠放置",
            value: "1",
          }
        ],
      }
    },
    watch:{
      user(val) {
        this.form = {
          ...this.initialization,
          id:val.id,
          ...this.setup,
        };
      }
    },
    created() {
    },
    mounted() {
    },
    activated() {
    },
    methods: {
      // 提示
      prompt(){
        this.$message({message:"点击右上角的编辑按钮进行编辑操作"});
      },
      //提交
      handleSubmit() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            updateInfo(this.$qs.stringify({
              id:this.form.id,
              extendPro: crypto.encryptAES(JSON.stringify({
                labelClose:this.form.labelClose,
                topMenu:this.form.topMenu,
                watermarking:this.form.watermarking,
              }), crypto.aesKey)
            })).then(res=>{
              this.$emit('success');
              this.$message.success("设置成功!");
              this.changeClick(); // 水印
              this.$store.dispatch("getPersonalization"); // 获取个性化配置
            });
          } else {
            this.$message.warning("请输入必填信息!")
          }
        });
      },
      // 是否开启水印
      changeClick(){
        // console.log(res);
        if(this.form.watermarking==1){
          this.index.submit();
        }else{
          this.index.del();
        }
      },
      clearValidateorForm(){
        this.form = {
          ...this.initialization,
          id:this.user.id,
          ...this.setup
        };
      }
    },
  }
</script>

<style lang="scss" scoped>
  /deep/.el-form-item{
    margin-bottom: 1px;
  }
  /deep/.el-form-item__content{
    span{
      font-size: 15px !important;
    }
  }
  .zcr{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
  }

</style>
